import _ from 'lodash'
import DocumentsGardener from 'scoreboard/documents/documents-gardener'
import { Transform } from 'stream'

/**
 * A DocumentsGardener that disables nodes that don't have a fileType
 * of 'spreadsheet' (#32960)
 */
const SpreadsheetDocumentsGardener = DocumentsGardener.extend({

	_treeOptions: function () {
		let treeOptions = DocumentsGardener.prototype._treeOptions.apply(this, arguments)

		let map = new Transform({objectMode: true})
		map._transform = function (node, enc, next) {
			if (_.lowerCase(node.fileType) != 'spreadsheet') {
				node.className = 'is-disabled'
			}
			this.push(node)
			next()
		}
		treeOptions.stream = treeOptions.stream.pipe(map)

		return treeOptions
	}
})

export default SpreadsheetDocumentsGardener

SpreadsheetDocumentsGardener.__filename__ = 'imports/spreadsheet-documents-gardener.js'
